import { Parser } from 'htmlparser2';
import { uniq } from 'lodash';
import { escapeRegExp } from '../../helper';
import ReplaceHandler from '../../shared/ReplaceHandler';

export const name = 'highlight';
export const defaultProp = [];

export const toHighlight = t => `<rich-text-highlight class="rte-highlight-standard">${t}</rich-text-highlight>`;

class Handler extends ReplaceHandler {
    constructor(appendFn, words) {
        const regex = new RegExp(`(${words.map(escapeRegExp).join('|')})+`, 'gi');
        super(appendFn, regex, toHighlight);
    }
}

export const onParse = (content, words) => {
    if (!words || words.every(word => !word)) {
        return content;
    }
    words = uniq(words);

    let results = '';

    const parser = new Parser(new Handler(s => (results += s), words), { decodeEntities: false });
    parser.write(content);
    parser.end();

    return results;
};
